import { opendoorUrl } from '@/lib/urls';

export type NavLink = {
  label: string;
  href: string;
  description?: string;
};

export type NavColumn = {
  heading: string;
  links: NavLink[];
};

export type NavGroup = {
  label: string;
  href?: string;
  columns?: NavColumn[];
};

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Sell',
    columns: [
      {
        heading: 'Ways to Sell',
        links: [
          { label: 'All Cash Offer', href: opendoorUrl('/how-it-works-sell') },
          { label: 'Cash Now More Later', href: opendoorUrl('/cash-now-more-later') },
        ],
      },
      {
        heading: 'Home Selling Resources',
        links: [
          {
            label: 'Sell my home for cash',
            href: opendoorUrl('/articles/sell-your-house-for-fast-cash-with-Opendoor'),
          },
          {
            label: 'How to Sell Your House',
            href: opendoorUrl('/articles/how-to-sell-your-house-fast-complete-guide'),
          },
          {
            label: 'Hidden Selling Fees',
            href: opendoorUrl('/articles/hidden-fees-when-selling-a-house'),
          },
          {
            label: 'Why Homes Don’t Sell',
            href: opendoorUrl('/articles/cant-sell-my-house-why-its-happening-and-how-to-fix-it'),
          },
        ],
      },
      {
        heading: 'Tools',
        links: [
          { label: 'Get my cash offer', href: opendoorUrl('/address-entry') },
          {
            label: 'How Much Is My House Worth',
            href: opendoorUrl(
              '/articles/how-much-is-my-house-worth-7-ways-to-find-out-your-homes-value',
            ),
          },
          {
            label: 'How To Determine Your Home’s Value',
            href: opendoorUrl('/articles/factors-that-influence-home-value'),
          },
          { label: 'Browse All', href: opendoorUrl('/articles/topic/sell') },
        ],
      },
      {
        heading: 'Your Situation',
        links: [
          { label: 'Relocating for work', href: opendoorUrl('/relocation') },
          { label: 'Divorce or separation', href: opendoorUrl('/sell/divorce') },
          { label: 'Military or PCS move', href: opendoorUrl('/sell/military') },
        ],
      },
    ],
  },
  {
    label: 'Buy',
    columns: [
      {
        heading: 'Homes for sale',
        links: [
          { label: 'For sale in Atlanta', href: opendoorUrl('/homes/atlanta') },
          { label: 'For sale in Dallas', href: opendoorUrl('/homes/dallas') },
          { label: 'For sale in Charlotte', href: opendoorUrl('/homes/charlotte') },
          { label: 'Browse all', href: opendoorUrl('/homes') },
          { label: 'Buy from Opendoor', href: opendoorUrl('/buy-from-opendoor') },
        ],
      },
      {
        heading: 'Homebuying',
        links: [
          { label: 'How to buy a house', href: opendoorUrl('/articles/how-to-buy-a-house') },
          {
            label: 'Buy at the right time',
            href: opendoorUrl('/articles/best-time-to-buy-a-house'),
          },
          {
            label: 'Buy at the right price',
            href: opendoorUrl('/articles/how-much-house-can-i-afford'),
          },
          { label: 'Browse All', href: opendoorUrl('/articles/topic/buy') },
        ],
      },
      {
        heading: 'Tools',
        links: [{ label: 'Mortgage calculator', href: opendoorUrl('/mortgage-calculator') }],
      },
    ],
  },
  {
    label: 'Agents',
    href: opendoorUrl('/agents'),
  },
];

export const MORE_NAV_ITEMS: { label: string; href: string }[] = [
  { label: 'Help center', href: opendoorUrl('/help') },
  { label: 'Newsroom', href: opendoorUrl('/newsroom') },
  { label: 'Stories', href: opendoorUrl('/stories') },
  { label: 'About Opendoor', href: opendoorUrl('/about') },
  { label: 'Careers', href: opendoorUrl('/careers') },
  { label: 'Contact us', href: opendoorUrl('/contact-us') },
];

export const SIGN_IN_HREF = opendoorUrl('/login');
